import { Css, px, useTestIds } from "@homebound/beam";
import { getStage } from "src/context";

export function LocalProdEnvironmentWarning() {
  const localProdEnvironmentWarningId = useTestIds({}, "localProdEnvironmentWarning");
  const stage = getStage();

  if (stage !== "local-prod") {
    console.error(
      "The LocalProdEnvironmentWarning component was instantiated outside the local-prod environment. This should not happen! Please debug where this component is rendered.",
    );
    return null;
  }

  return (
    <div css={Css.bgRed100.fs0.w100.sticky.z999.h(px(48)).df.aic.mt2.$} {...localProdEnvironmentWarningId}>
      <div css={Css.mx3.$}>
        You are running the app from your local machine against production. Please exercise caution and do not make
        unintended changes to production data.
      </div>
    </div>
  );
}
